import * as React from "react";
import { forwardRef } from "react";
const SvgCamera = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 1C5.89543 1 5 1.89543 5 3L4 3C1.79086 3 0 4.79086 0 7V13C0 15.2091 1.79086 17 4 17H14C16.2091 17 18 15.2091 18 13V7C18 4.79086 16.2091 3 14 3H13C13 1.89543 12.1046 1 11 1H7ZM9 13C10.6569 13 12 11.6569 12 10C12 8.34315 10.6569 7 9 7C7.34315 7 6 8.34315 6 10C6 11.6569 7.34315 13 9 13Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgCamera);
export default ForwardRef;
